import type { ActionFunction } from '~/types/route-args';
import { data as routerData } from 'react-router';
import type {
    UpdateMemberSuburbMutation,
    UpdateMemberSuburbMutationVariables,
} from 'generated/graphql';
import { UpdateMemberSuburbDocument } from 'generated/documents/UpdateMemberSuburbDocument';

export const MEMBER_UPDATE_SUBURB_API_ROUTE = '/remix-api/member/update-suburb';

/** Persists the suburb/postcode JSON to the logged-in user's profile. */
export const action: ActionFunction = async ({ request, context }) => {
    const { client } = context;
    const form = await request.formData();
    const suburb = form.get('suburb')?.toString();

    if (!suburb) {
        return routerData({ error: 'Missing suburb value' }, { status: 400 });
    }

    const result = await client.mutate<
        UpdateMemberSuburbMutation,
        UpdateMemberSuburbMutationVariables
    >({
        mutation: UpdateMemberSuburbDocument,
        variables: { Suburb: suburb },
    });

    return { success: true, suburb: result.data?.updateMe?.Suburb };
};
